export const home = {
  title: 'Ocean Remote Sensing Big Data Information Service and Decision Center',
  Welcome: 'Welcome',
  introduce: 'The goal of Southern Ocean Laboratory is to build a marine innovation foundation platform facing the frontier of science and technology with international lead, to build a world-class marine talent highland, and to build an innovative, leading and breakthrough large-scale comprehensive marine research and application base.',
  Platform: 'Platform Announcement',
  ViewAll: 'View All',
  ProductCategoricalData: 'Product Categorical Data',
  MarineHydrology: 'Marine Hydrology',
  MarineMeteorology: 'Marine Meteorology',
  PolarMarine: 'Polar Marine',
  Topography: 'Topography',
  MarineBiology: 'Marine Biology',
  MarineEcology: 'Marine Ecology',
  ObservationData: 'Observation Data',
  SatelliteCategoricalData: 'Satellite Categorical Data',
  NumberofSatellites: `The Number of Satellites`,
  Scenesofdatafile: `Scenes of data file`,
  DataStorage: `Data Storage`,
  LatestProductData: 'Latest Product Data',
  PopularProductData: 'Popular Product Data',
  PictureoftheDay: 'Picture of theDay',
  CartographicInstitution: 'Cartographic Institution',
  CoordinateSystem: 'Coordinate System',
  ScaleBar: 'ScaleBar',
  ProcessingDate: 'Processing Date',
  NewsCenter: 'News Center',
  News: 'News',
  IndustryNews: 'Industry News',
  AlgorithmStatistics: 'Algorithm Statistics',
  TotalNumberofAlgorithms: 'Total Number of Algorithms',
  TotalNumberofProducedProducts: 'Total Number of Produced Products',
  TotalProducedDataVolume: 'Total Number of Product Data',
  ResourceStatistics: 'Resource Statistics',
  TotalNumberofProductData: 'Total Number of Product Data',
  TotalVolumeofProductData: 'Total Volume of Product Data',
  TotalNumberofSatelliteData: 'Total Number of Satellite Data',
  TotalVolumeofSatelliteData: 'Total Volume of Satellite Data',
  ServiceStatistic: 'Service Statistic',
  NumberofRegisteredUsers: 'Number of Registered Users',
  WebsiteVisits: 'Website Visits',
  TotalDownloadVolume: 'Total Download Volume',
  TotalDownloadCounts: 'Total Download Counts',
  PlatformAnnouncement: 'Platform Announcement',
  content: 'Content',
  time: 'Time',
  promulgator: 'promulgator',
  Datatime: 'Data Time',
  pcs: 'pcs',
  bar: 'bar',
  freq: 'times',
  scene: 'scene',
  scenes: 'scenes',
  Stars: 'Stars',
  Star: 'Star',
  set: 'set',
  person: 'person',
  persons: 'persons',
  GB: 'GB',
  TB: 'TB',
}
export const footer = {
  OfficialWeChat: 'Official WeChat',
  Address: 'Address',
  Address2: ' No. 4 Haiqin, Sun Yat-sen University (Zhuhai Campus), Tangjiawan Town, Xiangzhou District, Zhuhai, Guangdong.',
  copyright: '2021 Southern Marine Science and Engineering Guangdong Laboratory (Zhuhai)',
  TechnicalSupport: 'Technical Support',
  SunYatsenUniversity: 'Sun Yat-sen University',
  RelatedLinks: 'Related Links',
  Address3: 'Southern Marine Science and Engineering Guangdong Laboratory (Zhuhai)',
  Portal: 'Earth\'s Three Poles Data Sharing and Service Portal',
  InternetContentProvider: 'Guangdong ICP 19160455-1 No.',
}
export const header = {
  NightMode: 'NightMode',
  Login: 'Login',
  Register: 'Register',
  Welcome: 'Welcome',
  PersonalCenter: 'Personal Center',
  orderForm: 'Order Form',
  Logout: 'Logout',
  Home: 'Homepage',
  SatelliteData: 'Satellite Data',
  ProductData: 'Product Data',
  AlgorithmPlatform: 'Platform Algorithm',
  Maps: 'Maps',
  ServicesResource: 'Service Resources',
  DataDecisionMaking: 'Intelligent Decision',
  DataSubmission: 'Data Submission',
  About: 'About Us',
  AlgorithmScheduling: 'Algorithm Scheduling',
  DataService: 'Data Service',
  DataResource: 'Data Resource',
  OperationManagement: 'Operation Management',
  RPAManagement: 'RPA Management',
  RemoteSensingCloudComputingService: 'Remote Sensing Cloud Computing Service',
  CloudComputingServices: 'Cloud Computing Services(GP)',
  DevelopmentSDK: 'Development SDK',
  OrbitPrediction: 'Orbit Prediction',
  StormSurgeDisasterPrediction: 'Storm Surge Disaster Prediction',
  MarineDisasterPreventionandMitigation: 'Marine Disaster Prevention and Mitigation',
  MarineRedTideMonitoring: 'Marine Red Tide Monitoring',
  PolarSeaIceMonitoring: 'Polar Sea Ice Monitoring',
  NavigationSecurityinPolarSeaRoute: 'Navigation Security in Polar Sea Route',
  ProductUpload: 'Product Upload',
  ApplicationForSatelliteData: 'Application For SatelliteData',
  AlgorithmManagement: 'Algorithm Management',
  DataDistributionAndTransfer: 'Data Distribution And Transfer',
  AlgorithmsLibrary: 'Algorithms Library',
  IntroductionOfPlatform: 'Platform Introduction',
  LaboratoryIntroduction: 'Laboratory Introduction',
  ContactUS: 'ContactUS',
  OrganizationalStructure: 'Organizational Framework',
  DevelopmentHistory: 'Development History',
  Applyforremotesensingcloudcomputingservice: 'Apply for remote sensing cloud computing service',
  Applicationduration: 'Application Duration',
  Descriptionofuse: 'Description of use',
  EnvironmentType: 'Environment Type',
  Serviceconnection: 'Service connection',
  UsernameandPassword: 'Username/Password',
  Pleaseenteradescription: 'Please enter a description of use',
  Unit: 'Unit',
  Hour: 'Hour',
  Note: 'Note: The above is the last application information',
  Tips: 'Tips',
  Tips2: 'For the required remote sensing image catalog, please refer to the data resource module in the service resource module',
  ViewOperationVideo: 'View Operation Video',
  help: 'Help',
}
export const satellite = {
  ClassificationOfTheSatellite: 'Classification Of The Satellite',
  CurrentPosition: 'Current Position',
  Home: 'Home',
  SatelliteData: 'Satellite Data',
  placeholder: 'Please enter the content',
  ProductTypes: 'Product Types',
  All: 'All',
  Sensor: 'Sensor',
  Scenes: 'Scenes',
  DataVolume: 'Data Volume',
  Views: 'Views',
  Details: 'Details',
  Free: 'Free',
  ReleaseTime: 'Release Time',
  Downloads: 'Downloads',
  BasicInformation: 'Basic Information',
  DatasetName: 'Dataset Name',
  Resource: 'Resource',
  Satellite: 'Satellite',
  ProductLevel: 'Product Level',
  Resolution: 'Resolution',
  Format: 'Format',
  TimeSpan: 'Time Span',
  LatestTime: 'Latest Time',
  Entry: 'Entries(Scenes)',
  SharedScope: 'Shared Scope',
  CoverageArea: 'Coverage Area',
  DataRetrieval: 'Data Retrieval',
  CloudCoverSize: 'Cloud CoverSize',
  TimeRange: 'TimeRange',
  Start: 'Start',
  End: 'End',
  WithinOneWeek: 'Within One Week',
  WithinOneMonth: 'Within One Month',
  WithinOneQuarter: 'Within One Quarter',
  WithinHalfayear: 'Within Half a Year',
  Withinoneyear: 'Within one Year',
  SpaceLocation: 'Space Location',
  FullDataCoverage: 'Full Data Coverage',
  SearchbyMap: 'Search by Map',
  LongitudeandLatitude: 'Longitude and Latitude',
  AreaSearch: 'Area Search',
  ImportPolygon: 'Import Polygon',
  TaptoSelect: 'Tap to Select',
  Rectangle: 'Rectangle',
  Polygon: 'Polygon',
  reset: 'reset',
  Search: 'Search',
  longitude: 'longitude',
  latitude: 'latitude',
  latitude1: 'Please enter west longitude',
  latitude2: 'Please enter east longitude',
  latitude3: 'Please enter north latitude',
  latitude4: 'Please enter southern latitude',
  import: 'import',
  tips: 'Zip files, including. DBF,. SHP,. PRJ, and. KML files',
  productInstruction: 'Product Instruction',
  p1: '.The ownership of the satellite data belongs to the original organization and has been indicated in the data description.',
  p2: '.This platform is only used for scientific research work. It is forbidden to reforward it. It is forbidden to use it for any commercial purpose or other non scientific research purposes. If you need to use it, please contact the original institution for information.',
  p3: '.If there is any quotation, please indicate the name and data source of the original organization, and strictly comply with the use requirements of the original organization.',
  Arctic: 'Arctic',
  Antarctic: 'Antarctic',
  SouthChinaSea: 'South China Sea',
  EastChinaSea: 'East China Sea',
  YellowSea: 'Yellow Sea',
  BohaiSea: 'Bohai Sea',
  bridge: 'Guangdong-Hong Kong-Macao Greater Bay Area',
  dataidentifier: 'data identifier',
  Nothumbnail: 'No thumbnail',
  stripe: 'stripe',
  cloudcover: 'cloud cover',
  Upperleftlatitudeandlongitude: 'Upper left latitude and longitude',
  Upperrightlatitudeandlongitude: 'Upper right latitude and longitude',
  Lowerleftlatitudeandlongitude: 'Lower left latitude and longitude',
  Latitudeandlongitudeinlowerrightcorner: 'Latitude and longitude in lower right corner',
}
export const product = {
  ProductCategory: 'Product Category',
  ProductData: 'Product Data',
  Subject: 'Subject',
  ReleaseTime: 'Release Time',
  Salinity: 'Salinity',
  Datavolume: 'Data volume',
  Time: 'Time',
  Label: 'Label',
  LastUpdateTime: 'Last Update Time',
  DataAccessVolume: 'Data Access Volume',
  BasicInfo: 'Basic Info',
  DataContactInfo: 'Data Contact Info',
  Datatime: 'Data Time',
  SpaceLocation: 'Space Location',
  SubjectCategory: 'Subject Category',
  SharingLevel: 'Sharing Level',
  Contact: 'Contact',
  Phone: 'Phone',
  Mail: 'Email',
  Institution: 'Institution',
  Address: 'Address',
  DataAcquisitionMethod: 'Data Acquisition Method',
  AddDataOrder: 'Add Data Order',
  FillintheDataUsePurpose: 'Fill in the Data Use Purpose',
  DownloadDataOnline: 'Download Data Online',
  SubscribetoData: 'Subscribe to Data',
  subscribed: 'subscribed',
  Favoritedata: 'Favorite Data',
  Collected: 'Collected',
  ClicktoView: 'Click to View',
  DataSummary: 'Data Summary',
  DataAttachment: 'Data Attachment',
  DataDescriptionDocument: 'Data Description Document',
  DataSamples: 'DataSamples',
  DataUsageInformation: 'Data Usage Information',
  AcknowledgementFormat: 'Acknowledgement Format',
  AcknowledgmentRefertotheFollowingSpecifications: 'Acknowledgment Refer to the Following Specifications',
  AcknowledgmentinChinese: 'Acknowledgment in Chinese',
  p1: '"Thanks for the data service provided by the  Southern Marine Science and Engineering Guangdong Laboratory (Zhuhai)."',
  AcknowledgementinEnglish: 'Acknowledgement in English',
  Attention: 'Attention:',
  p2: '1.This data is for laboratory-related research purposes only, not for commercial use, not for public system development and display.',
  p3: '2.Data applicants are not allowed to disseminate the applied data without permission.',
  p4: '3.For papers and other achievements published using the requested data, the source of the data must be indicated and stated in the acknowledgment.',
  RelevantLiterature: 'Relevant Literature',
  p5: 'The Platform owns the copyright and other intellectual property rights to the data products or services published by it or contributed by the data contributors and all the contents of the relevant information posted on the platform, which are protected by law.',
  p6: 'Without the written permission of the platform, no institution or individual is allowed to copy, modify, transcribe, disseminate and sell any part of the above data products, services, information. and materials in any way or for any reason.',
  p7: 'Any infringement of the copyright and other intellectual property rights of the platform, the platform will be investigated for its legal responsibility in accordance with the law, hereby solemnly declare!',
  DataFile: 'Data File',
  DataFileName: 'Data File Name',
  FileType: 'File Type',
  FileSize: 'File Size',
  Createdtime: 'Created Time',
  Operation: 'Operation',
  Empty: 'Empty',
  AddtoCartinBulk: 'Add to Cart in Bulk',
  Addalltoshoppingcart: 'Add all to shopping cart',
  shoppingCar: 'shopping Car',
  DownloadedUser: 'Downloaded User',
  UserName: 'User Name',
  Remarks: 'Remarks',
  LatestViewData: 'Latest View Data',
  ProductOverview: 'Product Overview',
  MetadataInfo: 'Metadata Info',
  DataType: 'Data Type',
  SpatialResolution: 'Spatial Resolution',
  TemporalResolution: 'Temporal Resolution',
  SpatialPosition: 'Spatial Position',
  Datatimerange: 'Data Time Range',
  SourceDataofProduct: 'Source Data of Product',
  Websites: 'Product-related Papers/Websites',
  unit: 'unit',
  optiondate: 'Option Date',
  Introduction: 'Introduction to Data Science Background',
  DynamicAnalysis: 'Dynamic Statistical Analysis of Data',
  Maximum: 'Maximum',
  Average: 'Average',
  Minimum: 'Minimum',
  StandardDeviation: 'Standard Deviation',
  Value: 'Value',
  download: 'download',
  warning: 'Tips',
  clean: 'clean',
  DistanceMeasurement: 'measure Distance',
  AreaMeasurement: 'Area',
  Queryvalue: 'Query Value',
  Screenshot: 'Screen Shot',
  Recordscreen: 'Record Screen',
  Clear: 'Clear',
  Fullscreen: 'Full Screen',
  map2d: '2D map',
  map3d: '3D map',
  Searchfortherequireddata: 'Search for the required data',
  Addtodataorder: 'Add to data order',
  Downloaddataonline: 'Download data online',
  GameEngineEffects: 'Game Engine Effects',
}
export const algorithm = {
  algorithmClassification: 'algorithm Classification',
  AlgorithmData: 'Algorithm Data',
  AlgorithmContributors: 'Algorithm Contributors',
  DataContactInformation: 'Data Contact Information',
  AlgorithmStatus: 'Algorithm Status',
  OnlineTime: 'Online Time',
  SubjectCategory: 'Subject Category',
  SharingMetho: 'Sharing Method',
  Region: 'Region',
  TemporalResolution: 'Temporal Resolution',
  SpatialResolution: 'Spatial Resolution',
  ProgrammingLanguage: 'Programming Language',
  OperatingPlatform: 'Operating Platform',
  Modelcomplexity: 'Model complexity',
  Modeldrivingdata: 'Model-driving data',
  ModelOutputFormat: 'Model Output Format',
  AlgorithmicProductionStatistics: 'Algorithmic Production Statistics',
  DataAcquisitionMethod: 'Data Acquisition Method',
  DownloadExistingData: 'Download Existing Data',
  Applicationforoperation: 'Application for operation',
  AlgorithmSummary: 'Algorithm Summary',
  AlgorithmDescription: 'Algorithm Description',
  OutputProduct: 'Output Product',
  References: 'References',
  DataNeedsTime: 'Data Needs Time',
  SpatialRangeRequiredForData: 'Spatial Range Required ForData',
  Gettheoutputpath: 'Get the output path',
}
export const services = {
  Resolution: 'Resolution',
  calculating: 'calculating',
  Country: 'Country',
  SatelliteType: 'Satellite Type',
  SelectAll: 'Select All',
  ForecastTime: 'Forecast Time',
  OrbitType: 'Orbit Type',
  SelectAdministrativeRegion: 'Select Administrative Region',
  Pleaseselect: 'Please select',
  LoadOrbit: 'Load Orbit',
  ClearOrbit: 'Clear Orbit',
  ViewResult: 'View Result',
  SwingingAngle: 'Operate',
  play: 'play',
  Total: 'Total Effective Coverage of Transit Satellite',
  ExportOrbit: 'Export Orbit',
  name: 'name',
  Time: 'Time',
  Operation: 'Operation',
  introduce: 'Introduce',
  copy: 'copy',
  path: 'path',
  China: 'China',
  ESA: 'ESA',
  Japan: 'Japan',
  America: 'America',
  Descendingorbit: 'Descending orbit',
  Ascendingorbit: 'Ascending orbit',
  All: 'All',
  EntryTime: 'Entry Time',
  Departuretime: 'Departure Time',
  Multispectral: 'Multispectral',
  Microwave: 'Microwave',
  Laseraltimeter: 'Laser altimeter',
}
export const Intelligent = {
  IntelligentReport: 'Intelligent decision support Report',
  name: 'name',
  lookOver: 'view',
  NoData: 'No Data',
}
export const DataSubmission = {
  MyProduct: 'My Product',
  Add: 'Add',
  Delete: 'Delete',
  ProductName: 'Product Name',
  Edit: 'Edit',
  BasicInformation: 'Basic Information',
  DataParameterDescription: 'Data Parameter Description',
  DataAttachment: 'Data Attachment',
  BasicProductInformation: 'Basic Product Information',
  DownloadTemplate: 'Download Template',
  ProductCategory: 'Product Category',
  SearchbySubject: 'Search by Subject',
  Timespan: 'Timespan',
  SpatialLocation: 'Spatial Location',
  SubjectCategory: 'Subject Category',
  SharingLevel: 'Sharing Level',
  TemporalResolution: 'Temporal Resolution',
  TemporalResolutionUnit: 'Temporal Resolution Unit',
  ProductBasemap: 'Product Basemap',
  DataType: 'Data Type (Format)',
  InputData: 'Input Data',
  InputData2: 'If there is more than one, please split with ;',
  OtherIntroductionforData: 'Other Introduction for Data',
  ContactAddress: 'Contact Address',
  Cancel: 'Cancel',
  PreviousStep: 'Previous',
  NextStep: 'Next Step',
  DataDescription: 'Data Description',
  DataSummary: 'Data Summary',
  ProductThumbnail: 'Product Thumbnail',
  uploadpictures: 'upload pictures',
  ProductOverviewThumbnail: 'Product Overview Thumbnail',
  OtherIntroductionThumbnails: 'Other Introduction Thumbnails',
  legendType: 'legend Type',
  Visualdisplayornot: 'Visual display or not',
  yes: 'yes',
  no: 'no',
  continuity: 'continuity Colorbar',
  subsection: 'subsection Colorbar',
  ProductColorbar: 'Product Colorbar',
  StartValue: 'Start Value',
  NumberofLevels: 'Number of Levels',
  Stopvalue: 'Stop Value',
  Steplength: 'Step Length',
  color: 'color',
  value: 'value',
  name: 'name',
  DataUnit: 'DataUnit',
  coloreditor: 'Color Editor',
  preview: 'preview',
  confirm: 'confirm',
  DataDescriptionDocument: 'Data Description Document',
  ClicktoUpload: 'Click to Upload',
  SampleData: 'Sample Data',
  RelevantLiterature: 'Relevant Literature',
  Dataupload: 'Data Upload',
  p1: 'Please refer to the following catalog organization specifications when uploading product data',
  p2: 'Product data catalog organization specification',
  p3: 'Data sharing disk path',
  p4: 'Upload method description',
  p5: 'Shared disk path: you can use the tool to upload through the data common word disk path above',
  p6: 'Direct upload: please upload TIF files for image data. The supported file formats are TIF, tilt, etc. (the suffix is not case sensitive). The maximum size of a single file is no more than 10GB; Please upload shpfilc format file for vector data',
  p7: 'Drag the file to be uploaded',
  p8: 'Upload to server',
  finish: 'complete',
  title: 'Title',
  Satellite: 'Satellite',
  TimeRangeofData: 'Time Range of Data',
  SpatialScope: 'Spatial Scope',
  State: 'State',
  Operation: 'Operation',
  Applicationfornewsatellitedata: 'Application for new satellite data',
  Companyname: 'Company Name',
  Timerangeofapplicationdata: 'Time range of application data',
  Resourceprovider: 'Resource provider',
  telephone: 'telephone',
  Datadownloadaddress: 'Data download address',
  spatialresolution: 'spatial resolution',
  Descriptionofuse: 'Description of use',
  sensor: 'sensor',
  Productlevel: 'Product level',
  Applicationdataspacerange: 'Application data space range',
  Submit: 'Submit',
  Colorlessbelt: 'colorless belt',
  Submitaudit: 'Submit audit',
  Submittedforreview: 'Submitted for review',
  Toaudit: 'To audit',
}
export const algorithm2 = {
  MyAlgorithm: 'My Algorithm',
  AlgorithmName: 'Algorithm Name',
  AlgorithmClassification: 'Algorithm Classification',
  TemporalResolution: 'Temporal Resolution',
  OutputProductName: 'Output Product Name',
  SpatialResolution: 'Spatial Resolution',
  SharingLevel: 'Sharing Level',
  ApprovalStatus: 'Approval Status',
  Operation: 'Operation',
  Edit: 'Edit',
  Submit: 'Submit',
  Fail: 'Fail',
  NotReviewed: 'Not Reviewed',
  Approved: 'Approved',
  ProgrammingLanguage: 'Programming Language',
  CompileEnvironment: 'Compile Environment',
  ModelOutputProductName: 'Model Output Product Name',
  Modelruncycle: 'Model Run Cycle',
  ModelOutputFormat: 'Model Output Format',
  AlgorithmCode: 'Algorithm Code',
  Related: 'Related',
  ProductSpatialResolution: 'Product Spatial Resolution',
  Productoverviewdescription: 'Product over view description',
  Introductiontoproductsciencebackground: 'Introduction to product science background',
  Scientificbackgroundintroductionthumbnail: 'Scientific background introduction thumbnail',
  DistributionTime: 'Distribution Time',
  name: 'name',
  Institution: 'Institution',
  Amountofdatadistributed: 'Amount of data distributed',
}
export const about = {
  p1: 'The platform focuses on the Guangdong-Hong Kong-Macao Greater Bay Area, the South China Sea and the polar regions, collects various data, scientific algorithms and big data mining methods of "Sky, Earth and People", accesses various open data at home and abroad, realizes automatic data collection, and saves basic data collection time . The platform will integrate the algorithm resources of the laboratory, realize standardized and unified management, and display it with rich 2D and 3D visualization effects. The platform can provide users with online cloud computing services, and can realize online automated production of special products based on embedded algorithms and database data. While building a cloud service and computing platform for ocean remote sensing big data, it produces innovative special products with independent intellectual property rights, and provides special reports based on expert and intelligent decision-making system analysis, realizing the leap from conventional data sharing to application decision support. Serving the major needs of many countries and regions such as environmental monitoring, resource development, disaster warning and military security in the Guangdong-Hong Kong-Macao Greater Bay Area, the South China Sea and the polar regions.',
  p2: 'In order to thoroughly implement the spirit of General Secretary Xi Jinping\'s important speech of inspection of Guangdong, vigorously implement the innovation-driven development strategy and promote high-quality development, the Guangdong Provincial Government decided to build the Guangdong Provincial Laboratory. The Southern Marine Science and Engineering Guangdong Laboratory (Zhuhai) (hereinafter referred to as the Southern Marine Laboratory) started its construction in November 2018 and held the unveiling ceremony and the inaugural meeting of the Council on December 26, 2018.',
  p3: 'The Southern Marine Laboratory is organized by the Zhuhai Municipal People\'s Government.Sun Yat-sen University takes the lead in the construction and management process, and the Laboratory Director Responsibility System under the leadership of the Council is implemented. Academician Chen Dake is the director of the laboratory, and Academician Su Jilan is the director of the academic committee. The first academic committee of the The Southern Marine Laboratory consists of 19 academicians from the Chinese Academy of Sciences and the Chinese Academy of Engineering and 12 top experts in the field of oceanography. The goals of the Southern Marine Laboratory are to build a marine innovative fundamental platform facing the frontier of science and technology with international leading level, to build a world-class marine talent highland, and to build an innovative, leading and breakthrough large-scale comprehensive marine research and application base.',
  p4: 'The Southern Marine Laboratory adopts the "1 + N" collaborative innovation model of "one entity, N cooperative institution" to unite the superior forces inside and outside the province, the country (territory), brings together the wisdom and strengths of "Guangdong, Hong Kong and Macao Bay Area", and create a good atmosphere for international cooperation. By 2020, the Southern Marine Laboratory has signed cooperation and co-construction agreements with 41 Colleges and Universities including universities in Hong Kong, Macau and Guangdong, research institutions, business departments and related enterprises.',
  p5: 'The Southern Marine Laboratory has built 18 innovation teams around three research fields: marine environment and resources, marine engineering and technology, and marine humanities and archaeology, with the standard of "advocating innovation and striving for the best". Through the innovation of mechanism and system, the laboratory innovation teams form close, stable and long-term substantive cooperation, implement major projects of multidisciplinary cross-integration, and strive to achieve innovative results in scientific frontiers, core technologies and practical applications of major projects to serve the national marine and regional socio-economic development.',
  p6: 'The main building of the laboratory is 100,000 square meters and locates in the beautiful seaside city, Zhuhai. Relying on the construction of the marine discipline building group in the Zhuhai campus of Sun Yat-sen University, with an overview of seaside and beautiful scenery, the building is expected to be completed in 2021. The Southern Marine Laboratory will rely on the 6,000-ton marine comprehensive scientific research practice ship, the "Tianhe-2" supercomputer, the deep-water semi-submersible platform, and the marine intelligent unmanned system network, to vigorously promote the construction of eight "world-class, domestic-leading" public platforms.',
  Contactus: 'Contact us',
  GeneralManagementDepartment: 'General Management Department',
  TechnologyDevelopmentDepartment: 'Technology Development Department',
  HumanResourceDepartment: 'Human Resource Department',
  FinancialAssetsDepartment: 'Financial Assets Department',
  CooperationandExchangeDepartment: 'Cooperation and Exchange Department',
  PlatformFacilitiesDepartment: 'Platform Facilities Department',
  OrganizationalFramework: 'Organizational Framework',
  DevelopmentHistory: 'Development History',
  name: 'ren hong kai',
}
export const Order = {
  MyOrder: 'MyOrder',
  Orderquery: 'Order Query',
  query: 'query',
  Please: 'enter the order number to query',
  number: 'No',
  OrderNo: 'OrderNo',
  subscriptiondate: 'Subscription Date',
  Downloadvalidity: 'Download validity',
  Numberofdata: 'Number of Data',
  Totaldatavolume: 'Total Data Volume',
  Orderstatus: 'Order Status',
  operation: 'Operation',
  download: 'Download',
  Orderdetails: 'Order Details',
  FTPinformation: 'FTP information',
  OneclickCopy: 'One Click Copy',
  ShoppingCart: 'Shopping Cart',
  filename: 'File Name',
  Productiontime: 'Production Time',
  thumbnail: 'Thumbnail',
  Productname: 'Product Name',
  datatype: 'Data Ttype',
  fileformat: 'File Format',
  filesize: 'File Size',
  Jointime: 'Join Time',
  Selected: 'Selected',
  Totaldatasize: 'Total Data Size',
  Generateorder: 'Generate Order',
  Deleteselecteddata: 'Delete Selected Data',
  clearcart: 'Clear Cart',
  Satellitedatadetails: 'Satellite Data Details',
  Sensorname: 'Sensor Name',
  DataNo: 'Data No',
  Datagenerationtime: 'Data Generation Time',
  Shoppingcartaddtime: 'Shopping Cart Add Time',
  Shootingtime: 'Shooting Time',
  Productdatadetails: 'Product Data Details',
  Productdocumentname: 'Product Document Name',
  Batchdelete: 'Batch Delete',
  Readytofinish: 'Ready To Finish',
  Oneclickordergeneration: 'One Click Order Generation',
  ViewingtheDownloadlist: 'Viewing the Download List',
  Oneclicktoobtainthedownloadaddress: 'One Click to Obtain the Download Address',
  Thedownloadperiodhasexpired: 'The Download Period has Expired',
  FileDownloadlist: 'File Download List',
  准备完成:'prepare to complete',
  提交订单:'submit order',
  数据准备:'data preparation',
  Ordergenerationinprogress:'Order Generation in Progress',
  Pleaseselectatleastonepieceofdata:'Please select at least one piece of data',
}
export const newsCenter = {
  NewsCenter: 'News Center',
  Newsheadline: 'News Headline',
  ReleaseTime: 'Release Time',
  Newstype: 'News Type',
  Publishedby: 'Published By',
}
export const personalCenter = {
  myCollection: 'my Collection',
  cancelCollection: 'Cancel Collection',
  Subscribetothetime: 'Subscribe to the Time',
  mysubscriptions: 'my Subscriptions',
  unsubscribe: 'un subscribe',
  mymessage: 'my Message',
  Allhavebeenread: 'all have been read',
  MessageContent: 'Message Content',
  Messagepushtime: 'Message Push Time',
  Messagepublisher: 'Message Publisher',
  unread: 'unread',
  read: 'read',
  addNews: 'add News',
  editNews: 'edit News',
  Coverthumbnail: 'Cover Thumbnail',
  submit: 'submit',
  Pleaseinputatitle: 'Please input a title',
  p:'Please enter a news summary and try to keep it to 100 words or more',
  NewsTrends:'News & Trends',
  industrytrends:'industry trends',
  laboratoryreport:'laboratory report',
  addannouncement:'add announcement',
  Pleaseenterbulletincontent:'Please enter bulletin content',
  systematicnotification:'systematic notification',
  Settinginvalid:'Setting Invalid',
  SystemNotificationcontent:'System Notification content',
  status:'status',
  invalid:'invalid',
  valid:'valid',
  Addannouncement:'add announcement',
  Pleaseenterthesystemnotificationcontent:'Please enter the system notification content',
  Reviewofsatellitedataapplications:'Review of satellite data applications',
  Audithasbeenpassed:'Audit has been passed',
  Auditfailed:'Audit failed',
  TO:'TO',
  Approved:'Approved',
  Downloadurl:'Download Url',
  nopass:'no pass',
  productaudit:'product audit',
  audit:'audit',
  alreadypassed:'already passed',
  dataformat:'data format',
  contactinformation:'contact information',
  datapresentation:'data presentation',
  algorithmaudit:'algorithm audit',
  algorithmofinformation:'algorithm of information',
  productinformation:'product information',
  Algorithmthumbnail:'Algorithm thumbnail',
  Algorithmcodedownload:'Algorithm code download',
  Downloadthecode:'Download the code',
  Cronexpression:'Cron expression',
  describe:'describe',
  Thedefaultstart:'The default start',
  Dismissthereason:'Dismiss the reason',
  normal:'normal',
  stop:'stop',
}
export const cloudComputing = {
  text: 'Remote sensing cloud computing platform is a set of professional cloud computing service platform for earth science based on container cloud technology. Based on elastic container environment of automatic management, multi-source remote sensing data processing, resource scheduling, real-time computing, batch computing, and deep learning framework, etc., it has built a remote sensing/mapping professional processing platform, a remote sensing real-time analysis, and calculation platform, and an artificial intelligence interpretation platform, providing integrated services for public users to conduct large-scale geographic data analysis and scientific research. The platform provides python, Java, C/C++, and other different compilation environments. By creating a new mode of “open + co-construction + sharing”, it mines the value of remote sensing data with high efficiency, low threshold, and low cost, enabling rapid application and innovation in the industry. It provides technical support for crucial work such as investigation, monitoring, evaluation, supervision, and law enforcement of marine, polar, natural resources, ecology, and meteorology, promoting the industrialization development of remote sensing applications.',
  ViewingDataResources:'Viewing Data Resources',
  AccountPassword:`Account/ \n Password`,
  Applyimmediately:'Apply Immediately',
  Operationguide:'Operation Guide',
  Blankenvironment:'Blank Environment',
  Generalalgorithmenvironment:'General algorithm environment',
  Deeplearningenvironment:'Deep learning environment',
  Mapsource:'Map Source',
  Tianditu:'Tian Di Tu',
  source:'source',
  Mapmode:'Map',
  Earthmode:'Earth',
  kilometre:'kilometre',
  statutemile:'statute mile',
  nauticalmile:'nautical mile',
  Chooseabasemap:'Choose a basemap',
}